import * as React from 'react';
/**
 *
 * Original name: folder history
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1077
 *
 */
export const FolderHistoryLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M11.674 16.5H5.75a.75.75 0 0 1-.75-.75V5.5h3.073a.745.745 0 0 1 .67.415L9.536 7.5H18.5v2.174c.527.12 1.033.32 1.5.592V6h-9.537l-.377-.756A2.237 2.237 0 0 0 8.072 4H3.5v11.75A2.25 2.25 0 0 0 5.75 18h6.516a5.385 5.385 0 0 1-.592-1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M17 11c-2.379 0-4 1.45-4 4s1.621 4 4 4 4-1.45 4-4-1.621-4-4-4Zm.5 4.5H15v-1h1.5v-2h1v3Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
